import React, { Component } from 'react';

class Header extends Component {
  render() {
    if (!this.props.data) return null;

    const { name, occupation, title, description } = this.props.data;

    return (
      <header id="home">
        <nav id="nav-wrap">
          <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
            Menu
          </a>
          <a className="mobile-btn" href="#home" title="Hide navigation">
            Close
          </a>

          <ul id="nav" className="nav">
            <li className="current">
              <a className="smoothscroll" href="#home">
                Home
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#about">
                About
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#resume">
                Resume
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#portfolio">
                Portfolio
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#testimonials">
                Testimonials
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#contact">
                Contact
              </a>
            </li>
          </ul>
        </nav>

        <div className="banner">
          <div className="banner-text">
            <h1 className="responsive-headline">{name}</h1>
            <h3>
              <span>{occupation}</span>
            </h3>
            {title && <h3>{title}</h3>}
            <p>{description}</p>
          </div>
        </div>

        <p className="scrolldown">
          <a className="smoothscroll" href="#about" aria-label="Scroll down">
            <i className="icon-down-circle"></i>
          </a>
        </p>
      </header>
    );
  }
}

export default Header;
